











import { Component, Mixins, Prop } from "vue-property-decorator";
import { HisInformation } from "../../../domain/his";
import { ScreenKinds, HisItemParameter } from "../../../domain/his/behavior";
import { IHisInformationSelectable } from "../../../domain/document/items/IHisInformationSelectable";
import { IHisInfoSelectDialog } from "../dialogs/IHisInfoSelectDialog";
import { IHisInformationGroupSource } from "../../../domain/his/groupInput/HisInformationGroupSource";
import HisInfoListSelectDialog from "../dialogs/HisInfoListSelectDialog.vue";
import HisInfoUserSelectDialog from "./HisInfoUserSelectDialog.vue";
import HisInfoDepartmentSelectDialog from "../dialogs/HisInfoDepartmentSelectDialog.vue";
import HisInfoInstitutionSelector from "../dialogs/HisInfoInstitutionSelector.vue";
import { EditingDocument } from "../../document/editor";

@Component({
  components: {
    HisInfoUserSelectDialog,
    HisInfoListSelectDialog,
    HisInfoDepartmentSelectDialog,
    HisInfoInstitutionSelector,
  },
})
export default class HisInfoSelectDialog extends Mixins() {
  @Prop()
  hisInformation: HisInformation;

  @Prop()
  editingDocument: EditingDocument;

  parameter: HisItemParameter;

  data(): any {
    return {
      parameter: null,
      selectedItems: null as any[],
    };
  }
  selectedItems: any[];

  get componentKey(): string {
    if (this.isInstitutionSelectItem()) {
      return "HisInfoInstitutionSelector";
    }
    switch (this.screenKind) {
      case ScreenKinds.Department: return "HisInfoDepartmentSelectDialog";
      case ScreenKinds.Doctor: return "HisInfoUserSelectDialog";
      case ScreenKinds.List: return "HisInfoListSelectDialog";
    }
    return undefined;
  }

  private isInstitutionSelectItem(): boolean {
    return this.parameter && this.parameter.isInstitutionSelect;
  }

  getDialog(): IHisInfoSelectDialog {
    const dialog = this.$refs.dialog;
    if (this.isInstitutionSelectItem()) {
      return dialog as HisInfoInstitutionSelector;
    }
    switch (this.screenKind) {
      case ScreenKinds.Department: return dialog as HisInfoDepartmentSelectDialog;
      case ScreenKinds.Doctor: return dialog as HisInfoUserSelectDialog;
      case ScreenKinds.List: return dialog as HisInfoListSelectDialog;
    }
    return undefined;
  }

  get screenKind(): ScreenKinds {
    if (this.parameter == null) { return null; }

    return this.parameter.screenKind;
  }

  /**
   * 戻り値がundefinedのときは選択画面が存在しない。
   * IHisInformationGroupSource.dataがnullのときクリア、undefinedのとき、キャンセル。
   */
  async show(item: IHisInformationSelectable): Promise<IHisInformationGroupSource> {
    this.parameter = item.hisItemParameter;
    this.selectedItems = item.selectedItems;
    await this.$nextTick();
    const dialog = this.getDialog();
    if (dialog == null) { return undefined; }
    
    return dialog.show();
  }
}
